var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(!_vm.editingProject)?_c('div',{attrs:{"id":"first-reviewer"}},[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.firstReviewerName))])]):_c('div',{attrs:{"id":"editing-first-reivewer"}},[_c('FirstReviewerForm',{attrs:{"firstReviewer":_vm.project.first_reviewer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }